<template>
  <div class="control">
    <input @input="redrawTrack" ref="custom_slider" type="range" v-model="current_value" :min="min" :max="max" :step="step"/>
    <label ref="track_label" class="columns is-mobile is-marginless is-paddingless" :style="printLabelOffsetStyle">
      <span v-for="(label, index) in labels" :key="index" class="column is-marginless is-paddingless">
        <span :class="[{ 'is-active' : isActiveIndex(index) }, { 'is-default' : !isActiveIndex(index) }]" v-html="label+`%`"></span>
      </span>
    </label>
  </div>
</template>
<script>
export default {
  name: 'InputRange',
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    defaultValue: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      min: 0,
      max: 0,
      step: 1,
      current_value: 1,
      offsetWidthPx: 0
    }
  },
  mounted () {
    this.max = this.labels.length - 1
    if (this.defaultValue.length > 0) {
      const _index = (element) => element === this.defaultValue
      const foundIndex = this.labels.findIndex(_index)
      if (foundIndex !== -1) {
        this.current_value = foundIndex
      }
    }
    let l = this.$refs['track_label']
    const parentWidth = l.clientWidth
    const divisor = (this.labels.length % 2 === 0) ? 4 : 2
    this.offsetWidthPx = Math.floor((parentWidth / this.labels.length) / divisor)
    this.redrawTrack()
  },
  computed: {
    printLabelOffsetStyle () {
      return `margin-left: -${this.offsetWidthPx}px!important;margin-right: -${this.offsetWidthPx}px!important;`
    }
  },
  methods: {
    redrawTrack () {
      let r = this.$refs['custom_slider']
      const currPercent = this.current_value === 0 ? 0 : (this.current_value / this.max) * 100
      r.style.background = `linear-gradient(to right, #29357f 0%, #29357f ${currPercent}%, #fff ${currPercent}%, white 100%)`
      r.style.borderRadius = '11px'
      if (this.defaultValue !== this.labels[this.current_value]) {
        this.$emit('custom-slider-updated', {
          index: this.current_value,
          value: this.labels[this.current_value]
        })
      }
    },
    isActiveIndex (index) {
      return parseInt(this.current_value) === index
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/utilities/_colors.scss";

/**
 * Base
 */
input[type=range] {
  height: 10px;
  -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
  width: 100%; /* Specific width is required for Firefox. */
  background: transparent; /* Otherwise white in Chrome */
}

input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
}

input[type=range]:focus {
  outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */
}

input[type=range]::-ms-track {
  width: 100%;
  cursor: pointer;
  /* Hides the slider so custom styles can be added */
  background: transparent;
  border-color: transparent;
  color: transparent;
}

/**
 * Thumb
 */
/* Special styling for WebKit/Blink */
input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  border: none;
  height: 30px;
  width: 30px;
  border-radius: 30px;
  cursor: pointer;
  background: color('blue-dark');
  margin-top: -11px; /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
}

/* All the same stuff for Firefox */
input[type=range]::-moz-range-thumb {
  border: none;
  height: 30px;
  width: 30px;
  border-radius: 30px;
  background: color('blue-dark');
  cursor: pointer;
}

/* All the same stuff for IE */
input[type=range]::-ms-thumb {
  border: none;
  height: 30px;
  width: 30px;
  border-radius: 30px;
  background: color('blue-dark');
  cursor: pointer;
}

/**
 * Track
 */
input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 10px;
  cursor: pointer;
  border-radius: 11px;
  color: #13bba4;
  border: solid 1px rgba(88, 89, 91, 0.32);
}

input[type=range]:focus::-webkit-slider-runnable-track {
  border-radius: 11px;
}

input[type=range]::-moz-range-track {
  width: 100%;
  height: 10px;
  cursor: pointer;
  border-radius: 11px;
  border: solid 1px rgba(88, 89, 91, 0.32);
}

input[type=range]::-ms-track {
  width: 100%;
  height: 10px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}

input[type=range]::-ms-fill-lower {
  background: #2a6495;
  border: solid 1px rgba(88, 89, 91, 0.32);
  border-radius: 3px;
}

input[type=range]:focus::-ms-fill-lower {
  background-color: color('blue-dark');
}

input[type=range]::-ms-fill-upper {
  border-radius: 11px;
  background-color: color('blue-dark');
  border: solid 1px rgba(88, 89, 91, 0.32);
}

input[type=range]:focus::-ms-fill-upper {
  background-color: color('blue-dark');
}

/**
 * Labels
 */
input {
  margin-bottom: 12px;
}

label > span {
  font-family: Open Sans;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: center;
  color: #58595b;
}

label > span > span.is-active {
  opacity: 1;
  font-weight: bold;
}

label > span > span.is-default {
  opacity: 0.6;
}

/*label > span:first-child {*/
/*  text-align: left;*/
/*}*/
/*label > span:last-child {*/
/*  text-align: right;*/
/*}*/
/*label {*/
/*  !*width: calc(100% + 50px);*!*/
/*  margin-left: -69px!important;*/
/*  margin-right: -69px!important;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/InputRange.vue